<template>
  <star-icon
    v-if="favorite"
  />
</template>

<script>
import {mapGetters, mapState} from 'vuex';
import StarIcon from '@/assets/img/starIcon';
import {GET_FAVORITES_IDS_RECURSIVELY} from '@/store/getterTypes';
import {FAVORITE_TYPES} from '@/const';

export default {
  name: 'FavoriteStarDisplay',
  components: {StarIcon},
  props: {
    event: {
      type: Object,
    },
  },
  computed: {
    ...mapState({
      favorites: ({favorite}) => favorite.favorites,
    }),
    ...mapGetters({
      isLogged: 'isLogged',
      ids: GET_FAVORITES_IDS_RECURSIVELY,
    }),
    favorite() {
      const participants = this.event.participants.some(({id, participant_group_id: group}) => {
        return this.ids[FAVORITE_TYPES.participant].includes(id) ||
          this.ids[FAVORITE_TYPES.group].includes(group);
      });
      const category = this.ids[FAVORITE_TYPES.category].includes(this.event.event_category_id);

      return participants || category;
    },
  },
};
</script>

<style scoped>
svg {
  fill: var(--theme-accent);
}
</style>
